import Layout from "../components/ui/layout";
import React, {useEffect} from "react";
import aboutAnimation from "../utils/aboutSectionAnimation";
import { Avatar } from "@nextui-org/avatar";
import { Card, CardBody } from "@nextui-org/card";
import {Button} from "@nextui-org/button";
import {techonologyIconList} from "../data/technologyIconList";
import {Tooltip} from "@nextui-org/tooltip";
import IconComponent from "../components/ui/icon";
import useDocumentTitle from "../utils/useDocumentTitle";
import {GithubSVG} from "../components/ui/icons";
import whoAmIData from "../data/whoAmIData.json";
import {Link} from "react-router";
import images from "../data/images";

const About = () => {
    console.log(images)

    useDocumentTitle('Mahri Ilmedova | About')

    useEffect(() => {
        const mq = window.matchMedia("(min-width: 1024px)");

        if (mq.matches) {
            aboutAnimation.whoAmIAnimation();
            aboutAnimation.professionAnimation();
            aboutAnimation.quoteAnimation();
            aboutAnimation.techonologyIconListAnimation();
            aboutAnimation.verticalImageAnimation();
            aboutAnimation.educationContentAnimation();
        } else {
            aboutAnimation.mobileAnimation();
        }
    }, []);

    const downloadResume = () => {
        const link = document.createElement('a');
        link.href = '/resume/Resume-Mahri-Ilmedova.pdf';
        link.download = 'Resume_Mahri_Ilmedova.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return (
        <Layout>
            <div className="grid grid-rows-3 grid-cols-4 lg:grid-cols-3 gap-5">
                <Card
                    className="col-span-full lg:row-start-2 lg:row-span-2 lg:col-start-2 lg:col-span-1 dark:foreground-bg rounded-xl">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="hidden lg:block icon icon-tabler icon-tabler-timeline absolute top-0 -right-7 stroke-green-100 dark:stroke-zinc-800"
                        width="170"
                        height="170"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path
                            stroke="none"
                            d="M0 0h24v24H0z"
                            fill="none"
                        ></path>
                        <path d="M4 16l6 -7l5 5l5 -6"></path>
                        <path d="M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M10 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M4 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                    </svg>
                    <CardBody className="flex-col items-center justify-center gap-2 m-auto">
                        <Avatar
                            name="Mahri Ilmedova"
                            src="/img/me.webp"
                            className="w-24 h-24 text-large brightness-90 opacity-100 rounded-full mb-2"
                        />
                        <h1 className="text-3xl font-bold mb-2">{whoAmIData.fullName}</h1>
                        <Button className="text-md mt-2 px-5 py-3 bg-green-200 font-medium dark:bg-zinc-700" onPress={downloadResume}>Download Resume</Button>
                    </CardBody>
                </Card>

                <Card
                    className="hidden lg:flex col-span-full lg:row-start-1 lg:row-span-1 lg:col-span-2 opacity-0 mobile-animation whoAmICard dark:foreground-bg rounded-xl p-1 ">
                    <CardBody className="gap-2 flex-wrap">
                        <div className="flex flex-col lg:flex-col gap-2">
                            <h2 className="text-md lg:text-2xl font-bold flex mb-2 justify-between">
                                <div className="flex items-center">
                                    <GithubSVG size={24} color={"#9ca3af"}/> &nbsp;
                                    Follow me on Github
                                </div>
                                <Link to={"https://github.com/ilmedova"} className="button rounded-lg px-3 py-1 text-sm lg:text-md font-medium bg-green-200 dark:bg-zinc-700">Follow</Link>
                            </h2>
                            <div className="text-lg text-gray-400 calendar">
                                <img src={"https://ghchart.rshah.org/ilmedova"} className="w-full" alt={"Github - " + whoAmIData.fullName}/>
                            </div>
                        </div>
                    </CardBody>
                </Card>

                <Card
                    className="col-span-full row-start-2 row-end-3 lg:row-start-2 lg:col-start-1 lg:col-span-1 bg-green-800 opacity-0 mobile-animation professionCard">
                    <CardBody className="justify-center items-center">
                        <h2 className="text-3xl lg:text-3xl font-bold text-center text-gray-100">
                            {whoAmIData.profession}
                        </h2>
                        <h2 className="text-xl lg:text-xl font-bold text-center text-gray-100">
                            {whoAmIData.area}
                        </h2>
                    </CardBody>
                </Card>

                <Card
                    className="hidden lg:flex col-span-2 lg:row-start-3 lg:row-span-1 lg:col-start-3 lg:col-span-1 bg-green-800 opacity-0 mobile-animation quoteCard">
                    <CardBody className="justify-center items-center lg:row-start-2 lg:cols-start-4">
                        <h2 className="text-3xl lg:text-3xl font-semibold text-center text-gray-100">
                            {whoAmIData.quote}
                        </h2>
                    </CardBody>
                </Card>

                <Card
                    className="col-span-full lg:row-start-3 lg:row-span-2 lg:col-start-1 lg:col-span-1 opacity-0 mobile-animation technologyIconList p-5">
                    <CardBody className="gap-4">
                        <h2 className="text-2xl font-bold text-center mb-2">
                            Technologies I use
                        </h2>
                        <div className="flex flex-wrap justify-center lg:justify-center gap-x-10 gap-y-6">
                            {techonologyIconList.map(({ name, icon }) => (
                                <Tooltip
                                    key={`technology-item-${name}`}
                                    content={name}>
                                    <IconComponent icon={icon} />
                                </Tooltip>
                            ))}
                        </div>
                    </CardBody>
                </Card>

                <Card
                    className="
                    hidden
                    lg:block
                    lg:row-start-1
                    lg:row-span-2
                    lg:col-start-3
                    h-auto
                    rounded-xl
                    relative
                    opacity-0
                    mobile-animation
                    verticalImage"
                    style={{backgroundImage: `url(${images[Math.floor(Math.random() * images.length)]})`, backgroundPosition: 'center center', backgroundSize: "cover"}}
                >
                </Card>

                <Card
                    className="col-span-full lg:row-start-4 lg:row-span-1 lg:col-start-2 lg:col-span-2 opacity-0 mobile-animation educationContent">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="hidden lg:block icon icon-tabler icon-tabler-timeline absolute top-0 -right-7 stroke-green-100 dark:stroke-zinc-800"
                        width="200"
                        height="200"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path
                            stroke="none"
                            d="M0 0h24v24H0z"
                            fill="none"
                        ></path>
                        <path d="M4 16l6 -7l5 5l5 -6"></path>
                        <path d="M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M10 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M4 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                    </svg>
                    <CardBody className="gap-2 flex-wrap p-5 text-start">
                        <div className="text-3xl font-bold">Who am I?</div>
                        <div className="text-lg text-gray-700 dark:text-gray-400">{whoAmIData.whoAmI} </div>
                    </CardBody>
                </Card>
            </div>
        </Layout>
    );
}

export default About;
